export default [
    {
      path: '/packageB/provident_fund/main',
      name: '/packageB/provident_fund/main',
      component: () => import(/* webpackChunkName: "packageB" */ '../views/packageB/provident_fund/main')
    },
    {
      path: '/pages/packageB/provident_fund/result',
      name: '/pages/packageB/provident_fund/result',
      component: () => import(/* webpackChunkName: "packageB" */ '../views/packageB/provident_fund/result')
    },
    {
      path: '/packageB/plates/main',
      name: '/packageB/plates/main',
      component: () => import(/* webpackChunkName: "packageB" */ '../views/packageB/plates/main')
    },
    {
      path: '/packageB/credit/main',
      name: '/packageB/credit/main',
      component: () => import(/* webpackChunkName: "packageB" */ '../views/packageB/credit/main')
    },
]